import { render, staticRenderFns } from "./MyRightDialog.vue?vue&type=template&id=2ceca32c&scoped=true&"
import script from "./MyRightDialog.vue?vue&type=script&lang=ts&"
export * from "./MyRightDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MyRightDialog.vue?vue&type=style&index=0&id=2ceca32c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceca32c",
  null
  
)

export default component.exports